import {
    Component,
    Input
} from '@angular/core';
import {
    ModalController,
    ToastController
} from 'ionic-angular';
import {
    PRODUCTO_DETALLE_PAGE
} from '../../pages/pages.constants';
import {
    Api
} from '../../providers';

@Component({
    selector: 'producto',
    templateUrl: 'producto.html'
})
export class ProductoComponent {
    public detalleAbierto: boolean = false;
    @Input('producto') producto;
    constructor(private _modal: ModalController, private _toast: ToastController, private _api: Api) {}

    verDetalle() {
        this._modal.create(PRODUCTO_DETALLE_PAGE, {
            producto: this.producto
        }).present();
    }

    agregar() {
        this._api.post('carrito', {
            producto: this.producto
        }).subscribe(() => {
            this._toast.create({
                message: 'Se agregó correctamente el producto a tu carrito',
                duration: 3000,
                cssClass: 'success'
            }).present();
        }, err => {
            this._toast.create({
                message: 'Se agregó correctamente el producto a tu carrito',
                duration: 3000,
                cssClass: 'success'
            }).present();
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/producto/producto.ts